import DataObject from '../../../common/model/DataObject';

import Counterparty from './Counterparty';

export default class CounterpartyLogo extends DataObject {
  getPropertyNames() {
    return [
      'guid',
      'imageDataUri'
    ];
  }

  getMappedProjectedPropertyValues() {
    return {
      guid: {
        classType: Counterparty,
        propertyName: 'guid',
        mode: 'overwrite',
        nestedPath: []
      }
    };
  }
}